import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, ScrollText } from "lucide-react";

function fmt(d) { try { return new Date(d).toLocaleString(); } catch { return d; } }

const ACTION_CLS = {
  login: "text-blue-400", upload: "text-emerald-400", publish: "text-emerald-400",
  delete_file: "text-red-400", delete_user: "text-red-400", download: "text-amber-400",
};

export default function Audit() {
  const [events, setEvents] = useState(null);
  useEffect(() => { api.get("/audit").then((r) => setEvents(r.data)).catch(() => setEvents([])); }, []);

  if (!events) return <div className="flex justify-center h-96 items-center text-slate-500"><Loader2 className="w-6 h-6 animate-spin" /></div>;

  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-display font-extrabold text-3xl text-white tracking-tight">Audit Log</h1>
        <p className="text-slate-400 mt-2">A complete history of views, uploads, edits, downloads and publishing actions.</p>
      </div>
      <div className="rounded-xl border border-white/5 bg-[#111827] overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-white/5 text-slate-500 text-xs uppercase tracking-wider"><th className="text-left p-4">Time</th><th className="text-left p-4">User</th><th className="text-left p-4">Action</th><th className="text-left p-4">Target</th></tr></thead>
          <tbody>
            {events.map((e) => (
              <tr key={e.id} className="border-b border-white/5 last:border-0">
                <td className="p-4 text-slate-500 text-xs font-mono whitespace-nowrap">{fmt(e.created_at)}</td>
                <td className="p-4 text-slate-300">{e.user_email || "system"}</td>
                <td className="p-4"><span className={`font-medium ${ACTION_CLS[e.action] || "text-slate-300"}`}>{e.action}</span></td>
                <td className="p-4 text-slate-500 text-xs">{e.target_type ? `${e.target_type}` : ""} {e.meta?.filename || ""}</td>
              </tr>
            ))}
            {events.length === 0 && <tr><td colSpan={4} className="p-16 text-center text-slate-600"><ScrollText className="w-8 h-8 mx-auto mb-3 text-slate-700" />No events yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
